import Alias from './alias'

export default Alias